import React, { useState } from 'react';
import { Input } from 'reactstrap';

export function InputTime({ time, extractTime, type, row }) {

  const [currentTime, setCurrentTime] = useState(time);

  const changeTime = (event) => {
    setCurrentTime(event.target.value);
  }

  extractTime(
    {
      time: currentTime,
      identifier: type,
      key: row
    }
  );

  return (
    <Input
      onChange={changeTime}
      value={currentTime}
      type="time"
      name="time"
      id="exampleTime"
      placeholder="datetime placeholder"
    />
  );
}
